import React from 'react';
import classNameBind from 'classnames/bind';
import styles from './RadioIcon.module.css';

const bindClasses = classNameBind.bind(styles);

const RadioIcon = ({
  disabled,
  selected,
}) => (
  <div className={bindClasses('outer-circle', { disabled, selected })}>
    <div className={bindClasses('inner-circle')} />
  </div>
);

export { RadioIcon };
